import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { useDispatch, useSelector } from 'react-redux';
import { fetchImages } from 'src/actions/imageAction';
import { fetchFiles } from '../../actions/FileAction';
import Loader from '../../component/Loader/Loader';
import Modal from '../../component/Modal/Modal';

const useStyles = makeStyles((theme) => ({
  gridList: {
    height: 450,
    width: 500
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden'
  }
}));

const ImageGridList = ({ tiles, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GridList cellHeight={160} className={classes.gridList} cols={3}>
        {tiles.map((tile, index) => (
          <GridListTile key={tile.img} cols={tile.cols || 1}>
            <img alt={tile.title} onClick={onClick(index)} src={tile.img} />
            <GridListTileBar
              title={tile.title}
              // subtitle={<span>by: {tile.author}</span>}
              // actionIcon={
              //   <IconButton aria-label={`info about ${tile.title}`} className={classes.icon}>
              //     <InfoIcon />
              //   </IconButton>
              // }
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
};

const SelectExisting = ({ visible, onCancel, onOk, isImages = true }) => {
  const dispatch = useDispatch();
  const files = useSelector(({ file }) => file.files);
  const images = useSelector(({ images }) => images.images);

  useEffect(() => {
    async function load() {
      dispatch(fetchFiles());
      dispatch(fetchImages());
    }

    load();
  }, [dispatch]);

  if (!files) {
    return <Loader />;
  }

  const onModalCancel = () => {
    onCancel();
  };

  const onImageSelect = (index) => {
    if (isImages) {
      return () => {
        onOk({ url: [...images, ...files][index].url });
      };
    }

    return () => {
      onOk({ url: files[index].url });
    };
  };

  const tiles = isImages
    ? [...images, ...files].map(({ url, name }) => {
        return {
          cols: 1,
          img: url,
          title: name
        };
      })
    : files.map(({ url, name }) => {
        return {
          cols: 1,
          img: url,
          title: name
        };
      });

  return (
    <div>
      <Modal
        // confirmLoading={confirmLoading}
        handleClose={onModalCancel}
        isModalOpen={visible}
        styles={{
          '& .MuiDialogContent-root': {
            paddingBottom: '64px'
          },
          width: '600px'
        }}
        titleContent={<h3 className="modal-title">Select the file</h3>}
      >
        <ImageGridList onClick={onImageSelect} tiles={tiles} />
      </Modal>
    </div>
  );
};

export default SelectExisting;
